"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newVariableMetadataObject = exports.VariableMetadataObjectBuilder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var factory_1 = require("./factory");
var builder_1 = require("../builder");
/**
 * Variable metadata object builder
 * See {@link Builder}
 *
 * @beta
 */
var VariableMetadataObjectBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(VariableMetadataObjectBuilder, _super);
    function VariableMetadataObjectBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return VariableMetadataObjectBuilder;
}(factory_1.MetadataObjectBuilder));
exports.VariableMetadataObjectBuilder = VariableMetadataObjectBuilder;
/**
 * Variable metadata object factory
 *
 * @param ref - variable reference
 * @param modifications - variable builder modifications to perform
 * @returns created variable metadata object
 * @beta
 */
exports.newVariableMetadataObject = function (ref, modifications) {
    if (modifications === void 0) { modifications = identity_1.default; }
    return builder_1.builderFactory(VariableMetadataObjectBuilder, { type: "variable", ref: ref }, modifications);
};
//# sourceMappingURL=variableFactory.js.map